import { useTranslation } from "react-i18next";

import { useDeleteItemLabel, type ItemLabel } from "@/api/items";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Props {
  tag: ItemLabel | null;
  onClose: () => void;
}

export function DeleteTagDialog({ tag, onClose }: Props) {
  const { t } = useTranslation();
  const del = useDeleteItemLabel();

  if (!tag) return null;

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("settings.tags.deleteTitle")}</DialogTitle>
        </DialogHeader>
        <p className="text-sm">{t("settings.tags.deleteConfirmation")}</p>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            {t("common.buttons.cancel")}
          </Button>
          <Button
            variant="destructive"
            disabled={del.isPending}
            onClick={async () => {
              await del.mutateAsync(tag.id);
              onClose();
            }}
          >
            {t("common.buttons.delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
